import SiteLogo from 'assets/images/autoraha-logo.svg';

export default function Header() {
  return (
    <header className="App-header">
      <a href="https://autoraha.fi/" target="_blank"><img src={SiteLogo} alt="Autoraha" /></a>
    </header>
  )
}